import { render, staticRenderFns } from "./projectly.vue?vue&type=template&id=3052befc&scoped=true&"
import script from "./projectly.vue?vue&type=script&lang=js&"
export * from "./projectly.vue?vue&type=script&lang=js&"
import style0 from "./projectly.vue?vue&type=style&index=0&id=3052befc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3052befc",
  null
  
)

export default component.exports